<template>
  <div class="item-wrap">
    <div class="item-content">
      <div class="item-content__left">
        <span class="rank">{{ rank }}</span>
        <span class="name">{{ storeItem.name }}</span>
      </div>
      <Progress
        stroke-color="#FF9900"
        class="first-line"
        :percent="(storeItem.value * 100) / this.totalNum"
        :stroke-width="3"
        text-inside
      />
      <div class="item-content__right">{{ storeItem.value }}家</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    storeItem: {
      type: Object,
    },
    storeIndex: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
    totalNum: {
      type: Number,
    },
  },
  computed: {
    rank() {
      return this.storeIndex + 1 + (this.currentPage - 1) * 5;
    },
  },
};
</script>

<style lang="less" scoped>
.item-wrap {
  height: 40px;
  position: relative;
  .item-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__left{
      width: 160px;
      margin-right: 12px;
      .rank {
        font-size: 12px;
        font-weight: 600;
        display: inline-block;
        width: 22px;
        height: 22px;
        line-height: 22px;
        border-radius: 6px;
        background: #f0f0f0;
        color: #333333;
        text-align: center;
        margin-right: 6px;
      }
      .name{
        font-size: 13px;
      }
    }
    ::v-deep{
      .ivu-progress{
        margin-bottom: 6px;
        .ivu-progress-inner-text{
          display: none;
        }
      }
    }
    &__right{
      width: 40px;
      margin-left: 12px;
      text-align: right;
    }
  }
}
</style>
